import React, {FC} from "react"

import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {useIntl} from "@irati/utils/lang"

import Link from "@irati/ui/src/Link"
import {NorthrowLabel} from "./styled"

const NorthrowLink: FC = () => {
  const theme = useTheme()
  const {formatMessage} = useIntl()
  return (
    <NorthrowLabel small color={theme.colors.greys.grey50}>
      <FormattedMessage
        id="platform.selfSignUp.welcome.popUp.northrowInfo"
        values={{
          link: (
            <Link href={formatMessage({id: "platform.selfSignUp.welcome.popUp.northrowUrl"})} target="_blank">
              <FormattedMessage id="platform.selfSignUp.welcome.popUp.northrow" />
            </Link>
          )
        }}
      />
    </NorthrowLabel>
  )
}

export default NorthrowLink
